
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 20.5c0 3.605 1.404 6.995 3.954 9.545A13.412 13.412 0 0020.5 34c3.606 0 6.996-1.404 9.546-3.954A13.411 13.411 0 0034 20.5a13.41 13.41 0 00-3.954-9.546A13.412 13.412 0 0020.5 7a13.412 13.412 0 00-9.546 3.954A13.41 13.41 0 007 20.5zm-2 0C5 11.94 11.94 5 20.5 5 29.06 5 36 11.94 36 20.5 36 29.06 29.06 36 20.5 36 11.94 36 5 29.06 5 20.5z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.105 17.823l-5.832 5.831-1.414-1.414 7.246-7.245 7.246 7.245-1.414 1.414-5.832-5.83z"}})])
          )
        }
      }
    